class NodeHelper{
    static ToggleClass(node, toggleClass = 'is--active', activate = null){
        if(activate === null){
            node.classList.toggle(toggleClass)
        }else{
            node.classList.toggle(toggleClass, activate)
        }

        return node.classList.contains(toggleClass)
    }
}

export default NodeHelper;